/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_DOT_NAV_FILLED': {
    width: 16,
    height: 16,
    viewBox: '0 0 11 11',
    data: '<path pid="0" _fill="#4d4dff" d="M5.5 11A5.5 5.5 0 1 1 11 5.5 5.51 5.51 0 0 1 5.5 11z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_DOT_NAV_FILLED.js